import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute: React.FC = () => {
  const [authenticated, setAuthenticated] = useState<boolean | null>(null);
const sessionUrl =
  process.env.NODE_ENV === "production"
    ? "/api/auth/session"
    : "http://localhost:4000/api/auth/session";
  useEffect(() => {
    let active = true;

    const checkSession = async () => {
      try {
        const response = await fetch(sessionUrl, {
  method: "GET",
  credentials: "include",
  cache: "no-store",
});

        if (active) {
          setAuthenticated(response.ok);
        }
      } catch (error) {
        console.error("Session check failed:", error);

        if (active) {
          setAuthenticated(false);
        }
      }
    };

    checkSession();

    return () => {
      active = false;
    };
  }, []);

  if (authenticated === null) {
    return <div>Checking session...</div>;
  }

  if (!authenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;